import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from 'src/app/enums/state.enum';
import { EventResource } from 'src/app/interfaces/event-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EventService } from 'src/app/services/event.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-release',
  templateUrl: './release.component.html',
  styleUrls: ['./release.component.scss']
})
export class ReleaseComponent implements OnInit {
  /**
   * The Array of events to be shown
   */
  public allEvents: Array<EventResource> = [];
  /**
   * The current Page
   */
  page = null;
  /**
   * The current Page Metadata
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  /**
   * Has the page been loaded
   */
  loaded: boolean = false;
  /**
   * The Form to Filter the Events
   */
  filterForm: UntypedFormGroup;
  /**
   * 
   * @param eventService 
   * @param overlayService 
   * @param fb 
   * @param router 
   * @param route 
   * @param authenticationService 
   */
  constructor(
    private eventService: EventService,
    private overlayService: OverlayService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public authenticationService: AuthenticationService) {
    this.filterForm = this.fb.group({
      search: ['', []]
    })
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.eventService.mergeEventsFromV1andV2(this.pageData.pageIndex, this.pageData.pageSize, ['CREATED'], null, null, null).subscribe(value => {
      this.page = value.page
      this.allEvents = value.content;
    })

  }
  /**
   * Activate an Event
   * @param event 
   */
  activate(event: EventResource) {
    event.state = State.ACTIVE;
    this.eventService.changeState(event).subscribe(change => {
      this.overlayService.openSnackBar('Aktion wurde erfolgreich aktiviert!');
      this.eventService.mergeEventsFromV1andV2(this.pageData.pageIndex, this.pageData.pageSize, ['CREATED'], null, null, null).subscribe(value => {
        this.page = value.page
        this.allEvents = value.content;
      })
    })
  }

  /**
   * Deactivate an Event
   * @param event 
   */
  deactivate(event: EventResource) {
    event.state = State.CANCELLED;
    this.eventService.changeState(event).subscribe(change => {
      this.overlayService.openSnackBar('Aktion wurde erfolgreich abgelehnt!');
      this.eventService.mergeEventsFromV1andV2(this.pageData.pageIndex, this.pageData.pageSize, ['CREATED'], null, null, null).subscribe(value => {
        this.page = value.page
        this.allEvents = value.content;
      })
    })
  }
  /**
   * Get the Page of Events
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }

  /**
   * Filter for the Events
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.eventService.mergeEventsFromV1andV2(pageIndex, pageSize, ['CREATED'], null, null, null).subscribe((value: PagedResources<EventResource>) => {
      console.log("EVENTS Search: ", value)
      this.pageData.pageIndex = value.page.number;
      this.pageData.pageSize = value.page.size;
      this.page = value.page
      this.allEvents = value.content;
    })
  }
  /**
   * Get the Events
   */
  filterEvents() {
    this.eventService.mergeEventsFromV1andV2(this.pageData.pageIndex, this.pageData.pageSize, ['CREATED'], null, null, this.filterForm.value.search).subscribe((value: any) => {
      this.page = value.page
      this.allEvents = value.content;
      this.loaded = true;
    })
  }

}
